/**
 * NK - ストア情報ページ JavaScript
 * アンカーリンクのスムーズスクロールとページロード時のハッシュ処理（リトライ付き）
 */

(function() {
  'use strict';

  const TARGET_IDS = ['fukuoka', 'dazaifu', 'shingu'];

  // 固定ヘッダーとナビの合計高さを取得
  function getOffsetHeight() {
    const headerHeight = getComputedStyle(document.documentElement)
      .getPropertyValue('--header-height');

    let offset = 0;

    if (headerHeight && headerHeight !== '') {
      const parsed = parseInt(headerHeight, 10);
      if (!isNaN(parsed) && parsed > 0) {
        offset += parsed;
      }
    }

    // フォールバック: ヘッダー要素の高さ
    if (offset === 0) {
      const header = document.querySelector('.section-header');
      if (header) {
        offset += header.offsetHeight;
      }
    }

    // ストアナビがstickyの場合はその高さも加味
    const nav = document.querySelector('.nk-store-navigation');
    if (nav) {
      const navStyle = getComputedStyle(nav);
      const isSticky = navStyle.position === 'sticky' || navStyle.position === 'fixed';
      if (isSticky) {
        offset += nav.offsetHeight;
      }
    }

    // 最低オフセット（ヘッダー+ナビが取得できない場合の保険）
    return Math.max(offset + 8, 110);
  }

  // IDを解決（nk-store-v2形式にも対応）
  function resolveTargetId(baseId) {
    // まず nk-store-v2- プレフィックス付きを試す
    const v2Id = `nk-store-v2-${baseId}`;
    if (document.getElementById(v2Id)) {
      return v2Id;
    }
    // 次に通常のIDを試す
    if (document.getElementById(baseId)) {
      return baseId;
    }
    return null;
  }

  // ターゲット要素までスクロール
  function scrollToTarget(targetId, immediate) {
    // IDを解決（nk-store-v2形式にも対応）
    const resolvedId = resolveTargetId(targetId);
    if (!resolvedId) {
      return false;
    }

    const target = document.getElementById(resolvedId);
    if (!target) {
      return false;
    }

    const offset = getOffsetHeight();
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: Math.max(0, offsetPosition),
      behavior: immediate ? 'auto' : 'smooth'
    });

    return true;
  }

  // リトライ付きスクロール（要素描画待ちに対応）
  function scrollWithRetry(targetId, attempts = 6, delay = 180) {
    let tried = 0;
    const tryScroll = () => {
      const ok = scrollToTarget(targetId, false);
      tried += 1;
      if (!ok && tried < attempts) {
        setTimeout(tryScroll, delay);
      }
    };
    tryScroll();
  }

  // アンカーリンクのスムーズスクロール処理
  function handleAnchorClick(e) {
    const href = e.currentTarget.getAttribute('href');
    if (!href || !href.startsWith('#')) {
      return;
    }

    const targetId = href.substring(1);
    if (TARGET_IDS.includes(targetId)) {
      e.preventDefault();
      history.pushState(null, null, href);
      scrollWithRetry(targetId);
    }
  }

  // ページロード時のハッシュ処理
  function handleHashOnLoad() {
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      const targetId = hash.substring(1);
      if (TARGET_IDS.includes(targetId)) {
        scrollWithRetry(targetId, 8, 180);
      }
    }
  }

  // 初期化関数
  function initStorePage() {
    // アンカーリンクにイベントリスナーを追加（対象IDのみ）
    const selector = TARGET_IDS.map(id => `a[href="#${id}"]`).join(',');
    document.querySelectorAll(selector).forEach(link => {
      link.addEventListener('click', handleAnchorClick);
    });

    // 初回: DOMContentLoaded 時に試行
    handleHashOnLoad();

    // 画像等の読み込み完了後にも再試行
    window.addEventListener('load', () => {
      setTimeout(handleHashOnLoad, 240);
    }, { once: true });

    // ブラウザ戻る/進む
    window.addEventListener('hashchange', () => {
      setTimeout(handleHashOnLoad, 120);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStorePage);
  } else {
    initStorePage();
  }
})();

